import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowRight } from 'lucide-react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import { GlassCard } from '@/components/brand/GlassCard';
import { GlowButton } from '@/components/brand/GlowButton';

export default function PaymentCancelPage() {
    return (
        <div className="bg-la-canvas text-la-text min-h-screen">
            <Navbar />
            <main className="pt-32 pb-24">
                <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">
                    <GlassCard className="p-10">
                        <XCircle className="mx-auto h-12 w-12 text-la-text2" />
                        <h1 className="mt-6 font-display text-3xl text-la-text">Payment cancelled</h1>
                        <p className="mt-3 text-la-text2">No charge was made. You can return to the payment page or contact the firm if you would like assistance.</p>
                        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
                            <GlowButton as={Link} to="/pay" className="group">Try again <ArrowRight className="h-4 w-4" /></GlowButton>
                            <GlowButton as={Link} to="/contact" variant="ghost">Contact the firm</GlowButton>
                        </div>
                    </GlassCard>
                </div>
            </main>
            <Footer />
        </div>
    );
}
